import PropTypes from 'prop-types';
import { useContext, useRef } from 'react';
import * as yup from 'yup';
import AuthContext from 'context/authContext';
import CrudCard from '../../common/CrudCard/CrudCard';
import {
  useTransactionFees,
  useCreateTransactionFee,
  useUpdateTransactionFee,
  useDeleteTransactionFee
} from 'hooks/useDonationSettings';

export const FEE_TYPE_PERCENTAGE = 'percentage';
export const FEE_TYPE_FIXED = 'fixed';

const feeTypeOptions = [
  {
    value: FEE_TYPE_FIXED,
    label: 'Fixed'
  },
  {
    value: FEE_TYPE_PERCENTAGE,
    label: 'Percentage'
  }
];

/* -------------------------------------------------------------------------- */
function TransactionFees({ sectionRef, sideNavLink, subject }) {
  const cardRef = useRef();
  const { organization } = useContext(AuthContext);

  const { transactionFees, isLoading: loading } = useTransactionFees();
  const { createTransactionFee, isCreating: createLoading } = useCreateTransactionFee();
  const { updateTransactionFee, isUpdating: updateLoading } = useUpdateTransactionFee();
  const { deleteTransactionFee, isDeleting: deleteLoading } = useDeleteTransactionFee();

  const handleCreate = async (data) => {
    try {
      await createTransactionFee({
        amount: data.amount,
        fee_type: data.fee_type,
        organisation_id: organization.id
      });
      cardRef.current.onCreationSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  const handleEdit = async (data) => {
    try {
      await updateTransactionFee({
        id: data.id,
        data: {
          amount: data.data.amount,
          fee_type: data.data.fee_type
        }
      });
      cardRef.current.onEditSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteTransactionFee(id);
      cardRef.current.onDeleteSuccess();
    } catch (error) {
      console.error(error);
    }
  };

  const list = transactionFees?.map(fee => ({
    id: fee.id,
    isOrgLevel: !fee.branch_id,
    values: [
      {
        value: fee.amount,
        display:
          fee.fee_type === FEE_TYPE_PERCENTAGE
            ? `${fee.amount} %`
            : `£${fee.amount}`,
        name: 'amount'
      },
      {
        value: fee.fee_type,
        display: feeTypeOptions.find(option => option.value === fee.fee_type)
          .label,
        name: 'fee_type'
      }
    ]
  }));
  // const handleOpenChange = isOpen => {
  //   setIsOpen(isOpen);
  // };
  return (
    <CrudCard
      ref={cardRef}
      sectionRef={sectionRef}
      sideNavLink={sideNavLink}
      createData={handleCreate}
      loading={loading}
      editData={handleEdit}
      deleteData={handleDelete}
      createLoading={createLoading}
      updateLoading={updateLoading}
      deleteLoading={deleteLoading}
      // formTitle={'Add Transaction Fees'}
      listTitle={'Current Transaction Fees'}
      title={'Transaction Fees'}
      inputs={[
        {
          name: 'amount',
          placeholder: 'Add Transaction Fee',
          type: 'text',
          required: true,
          value: '',
          validation: yup
            .number()
            .typeError('Transaction Fee must be a number')
            .required('Transaction Fee is required'),
          label: 'Transaction Fee Amount'
        },
        {
          name: 'fee_type',
          placeholder: 'Add Fee Type',
          type: 'select',
          required: true,
          value: '',
          validation: yup.string().required('Fee Type is required'),
          label: 'Fee Type',
          options: feeTypeOptions
        }
      ]}
      list={list}
      subject={subject}
      // hasOpenCheck
      // handleOpenChange={handleOpenChange}
      // isOpen={isOpen}
    />
  );
}

TransactionFees.propTypes = {
  sectionRef: PropTypes.any,
  sideNavLink: PropTypes.any,
  subject: PropTypes.string
};

export default TransactionFees;
